const queryParams = new URLSearchParams(window.location.search);

export const getQueryParam = (param: string) => {
  return queryParams.get(param);
};
